import React, { useState } from "react";
import { Col, Row, Tabs } from "antd";
import { useSelector } from "react-redux";
import FeedFactoryIcon from "../../components/admin/sidebar/icons/feedFactory";
import DrawerSupplement from "../../components/drawers/supplement";
import DrawerSupplementDetails from "../../components/drawers/supplementDetails";
import SupplementGroupTable from "./components/SupplementGroupTable";
import ProductionOrderTable from "./components/ProductionOrderTable";
import ProductionTable from "./components/ProductionTable";
import FeedingAutomationTable from "./components/FeedingAutomationTable";
import { PageTitle } from "./components/styles";
import DrawerSupplementFormulated from "../../components/drawers/supplementFormulated";

const { TabPane } = Tabs;

const RAW_MATERIAL_GROUP_ID = 1;

const FeedFactoryPage = () => {
  const { translation } = useSelector((state) => state.app);
  const [activeTab, setActiveTab] = useState("0");

  return (
    <div style={{ padding: "14px 0 24px 0" }}>
      <Row type="flex" style={{ marginBottom: "1rem" }}>
        <Col span={24}>
          <PageTitle>
            <FeedFactoryIcon />
            <span>{translation.sidebar.feedFactory}</span>
          </PageTitle>
        </Col>
      </Row>
      <Tabs activeKey={activeTab} onChange={setActiveTab} type="card">
        <TabPane tab={translation.feedFactory.tabs.rawMaterials} key="0">
          <SupplementGroupTable
            isJustRawMaterials={true}
            groupFilterExpression={`supplement_group_id = ${RAW_MATERIAL_GROUP_ID}`}
            createButtonLabel={translation.feedFactory.buttonNewRawMaterial}
            defaultSupplementGroupId={RAW_MATERIAL_GROUP_ID}
            showGroupColumn={false}
          />
        </TabPane>
        <TabPane tab={translation.feedFactory.tabs.supplements} key="1">
          <SupplementGroupTable
            isJustRawMaterials={false}
            groupFilterExpression={`supplement_group_id <> ${RAW_MATERIAL_GROUP_ID}`}
            createButtonLabel={translation.supplement.buttonNewSupplement}
            defaultSupplementGroupId={null}
            showGroupColumn={true}
          />
        </TabPane>
        <TabPane tab={translation.feedFactory.tabs.productionOrders} key="2">
          <ProductionOrderTable />
        </TabPane>
        <TabPane tab={translation.feedFactory.tabs.production} key="3">
          <ProductionTable />
        </TabPane>
        <TabPane tab={translation.feedFactory.tabs.feedingAutomation} key="4">
          <FeedingAutomationTable />
        </TabPane>
      </Tabs>
      <DrawerSupplement />
      <DrawerSupplementFormulated />
      <DrawerSupplementDetails />
    </div>
  );
};

export default FeedFactoryPage;
